<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-20 pt-md-6">

            <!-- Loading-->
            <template v-if="loading">
              <div class="m-4">
                <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
              </div>
               <div class="m-4">
                <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
              </div>
               <div class="m-4">
                <skeleton altura="300px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
              </div>
               <div class="m-4">
                <skeleton altura="300px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
              </div>
            </template>
            
            <!-- SearchDate Inputs -->
            <div class="row text-right"  v-if="!loading">
               <div class="col-xl-12 col-lg-12" style="display: flex; justify-content: end; margin-top: 30px">
                <base-input class="w-20" type="date" placeholder="De" v-model="dadosData.de"></base-input>
                <base-input class="w-20 ml-2 mr-2" type="date" placeholder="Até"  v-model="dadosData.ate"></base-input>
                 <div class="">
                  <base-button class="inline"  @click="buscarRelatorio()">Filtrar</base-button>
                 </div>
              </div>
            </div>

            <!-- Card stats -->
            <div class="row" v-if="!loading">
                <div class="col-xl-3 col-lg-4" v-if="hasLabInfo">
                    <stats-card title="Laboratórios"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.totalLabs"
                                icon="fas fa-flask"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">laboratórios que utiliza.</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4" v-if="hasDenInfo">
                    <stats-card title="Dentistas"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.totalDents"
                                icon="fas fa-user-ninja"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">dentistas ativos.</span>
                        </template>
                    </stats-card>
                </div>

                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total de Ordens"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.totalStart"
                                icon="fas fa-play"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens realizadas desde o início.</span>
                        </template>
                    </stats-card>
                </div>

                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Parciais de Ordens"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.totalDate"
                                icon="fas fa-thumbs-up"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens realizadas entre as datas.</span>
                        </template>
                    </stats-card>
                </div>

                 <div class="col-xl-3 col-lg-4">
                    <stats-card title="Ordens Aprovadas"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.ordensAprovado"
                                icon="fas fas fa-check"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens aprovadas entre as datas.</span>
                        </template>
                    </stats-card>
                </div>
            </div>



            <div class="row mt-4" v-if="!loading">
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Ordens em Aprovação"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.ordensAguardando"
                                icon="far fa-clock"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens aguardando aprovação.</span>
                        </template>
                    </stats-card>
                </div>

                  <div class="col-xl-3 col-lg-4">
                    <stats-card title="Ordens em Produção"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.ordensProducao"
                                icon="fas fa-hourglass-half"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens em produção.</span>
                        </template>
                    </stats-card>
                </div>

                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Ordens para Retirar"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.ordensRetirada"
                                icon="fas fa-box"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens aguardando retirada.</span>
                        </template>
                    </stats-card>
                </div>

                 <div class="col-xl-3 col-lg-4">
                    <stats-card title="Ordens Entregues"
                                type="gradient-primary"
                                v-bind:sub-title="ordensInfo.ordensEntregue"
                                icon="far fa-check-circle"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">ordens entregues.</span>
                        </template>
                    </stats-card>
                </div>
            </div>

        <div class="w-full mt-4" v-if="!loading">
            <card header-classes="bg-primary">
                <div slot="header" class="row align-items-center bg-primary">
                  <div class="col">
                        <h6 class="text-light text-uppercase ls-1 mb-1">Procedimentos</h6>
                        <h5 class="h3 text-white mb-0">Por data selecionada</h5>
                    </div>
                </div>

                <bar-chart

                        :height="350"
                        ref="barChart"
                        :chart-data="redBarChart2.chartData"
                >
                </bar-chart>
            </card>
        </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card type="primary" header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">visão geral</h6>
                                <h5 class="h3 text-white mb-0">Este ano</h5>
                            </div>
                            <div class="col">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item mr-2 mr-md-0">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{'bg-gradient-live text-black': bigLineChart.activeIndex === 0}"
                                           @click.prevent="initBigChart(0)">
                                            <span class="d-none d-md-block">Mês</span>
                                            <span class="d-md-none">Mês</span>
                                        </a>
                                    </li>
                                    <li class="nav-item" v-if="false">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{'bg-gradient-live text-black': bigLineChart.activeIndex === 1}"
                                           @click.prevent="initBigChart(1)">
                                            <span class="d-none d-md-block">Semana</span>
                                            <span class="d-md-none">Sem.</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart>

                    </card>
                </div>

                <div class="col-xl-4">
                    <card header-classes="bg-primary">
                        <div slot="header" class="row align-items-center bg-primary">
                          <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">Visão Semanal</h6>
                                <h5 class="h3 text-white mb-0">Esta semana</h5>
                            </div>
                        </div>

                        <bar-chart

                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </bar-chart>
                    </card>
                </div>
            </div>
            <!-- End charts-->

        </div>

    </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // data import
  import ordens from '@/cflow/ordens.js'
  import storage from 'storage';

  // Tables

  export default {
    components: {
      LineChart,
      BarChart
    },
    data() {
      return {
        loading: true,
        ordensInfo: {
          totalLabs: ' - ',
          totalDents: ' - ',
          totalStart: ' - ',
          totalDate: ' - ',
          ordensAguardando: ' - ',
          ordensAprovado: ' - ',
          ordensProducao: ' - ',
          ordensRetirada: ' - ',
          ordensEntregue: ' - ',
          ordensCancelado: ' - ',
          ordensRecusado: ' - '
        },
        hasLabInfo: false,
        hasDenInfo: false,
        dadosData: {
          de: null,
          ate: null
        },
        bigLineChart: {
          activeIndex: 0,
          chartData: {},
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {},
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart2: {
          extraOptions: chartConfigs.lineChartOptionsBlue,
          chartData: {}
        }
      };
    },
    methods: {
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Ordens de Serviço',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels:
            this.bigLineChart.labels[index]
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      formatDate: function formatDate(date) {
          var d = new Date(date),
              month = '' + (d.getMonth() + 1),
              day = '' + d.getDate(),
              year = d.getFullYear();

          if (month.length < 2) 
              month = '0' + month;
          if (day.length < 2) 
              day = '0' + day;

          return [year, month, day].join('-');
      },
      proceduleChart: function(orders) {

          var labels = orders['procedulesLabels'];
          var values = orders['procedulesValues'];

          var dataset = [{
              label: 'Procedimentos',
              data: values
          }];

          var chartData =  {
            labels: labels,
            datasets: dataset
          }

          this.redBarChart2.chartData = chartData;

      },
      weeklyChart: function(orders) {

          var weekley = [];
          for(var i = 0; i < 7; i++) {
            weekley[i] = orders['last7days'][i];
          }

          var dayOfWeek = orders['dayOfWeek'];
          var dayLeft = 6 - dayOfWeek;

          weekley = weekley.reverse();

          var leftWeek = weekley.slice(dayLeft, dayOfWeek);
          var restWeek = weekley.slice(dayOfWeek, 7);
          var theWeek = leftWeek.concat(restWeek);

          var dataset = [{
              label: 'Ordens de Serviço',
              data: theWeek
          }];

          var chartData =  {
            labels: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            datasets: dataset
          }

          this.redBarChart.chartData = chartData;

      },
      yearChart: function(orders) {

        var currentYear = orders['currentYear'];
        var monthOfYear = orders['monthOfYear'];
        var theYear = [];
        for(var i = 1; i <= 12; i++) {
          theYear[i-1] = currentYear[i] || 0
        }

        var labels = ['Jan', 'Fev', 'Mar', 'Abr','Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        labels = labels.slice(0, monthOfYear);

        this.bigLineChart.allData = [ theYear ]
        this.bigLineChart.labels = [ labels ],
        this.initBigChart(0);

      },
      initLoad: function() {

        var user = storage.get('user');
        if(user.tipo == 'den') this.hasLabInfo = true;
        if(user.tipo == 'lab') this.hasDenInfo = true;

        var date = new Date();
        var dadosData = this.dadosData;
        if(dadosData.de == null) dadosData.de = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
        if(dadosData.ate == null) dadosData.ate = this.formatDate(new Date());

        Promise.all([ordens.buscarRelatorio(dadosData)]).then( res => {

          if(!res) return;
          var orders = res[0].ordensInfo;
          for (const key in orders) {
            this.ordensInfo[key] = orders[key].toString();
          }

          this.proceduleChart(orders);
          this.weeklyChart(orders);
          this.yearChart(orders);
         
         this.loading = false;
         

        })
      },
      buscarRelatorio: function() {
        this.initLoad();
      }
    },
    mounted() {
      this.initLoad();
    }
  };
</script>
<style></style>
